import React, { Component } from 'react'
import { Spin, Divider, Table, DatePicker, Select, Form, Row, Col, ConfigProvider, Tooltip, Button,Input } from 'antd'
import API from '../../services/API'
import moment from 'moment'
import locale from 'antd/es/date-picker/locale/es_ES'
locale.lang.firstDayOfWeek = 5
const { WeekPicker } = DatePicker;
const { Option } = Select
import WeekPicker2 from '../../components/WeekPicker2'
import { getRangesWeeks } from '../../services/Utils'
class ReportAssistancesWeeklyContainer extends Component {
    state = {
        loading: true,
        data: [],
        users: [],
        years: [],
        subsidiaries: [],
        currentWeek: '',
        currentYear: 0,
        currentSubsidiary: '',
        query: '',
        startOfWeek: '',
        endOfWeek: '',
        currentUser: '',
        dateRange: '',
        user_id:'',
        user_id_exact: ''
    }

    constructor(props) {
        super()
        this.user = props.user
    }

    componentDidMount() {
        let localSubsidiary = JSON.parse(localStorage.getItem('sucursal'))
        if (localSubsidiary) {
            localSubsidiary = parseInt(localSubsidiary.id)
        }

        const currentWeek = this.getCurrentWeek()
        const currentYear = moment().year()
        const ranges = getRangesWeeks(currentYear)

        const indexFind = ranges.findIndex(f => f.value === currentWeek)
        const option = ranges[indexFind]

        this.setState(
            {
                currentWeek,
                currentYear,
                dateRange: `${option.start},${option.end}`,
                currentSubsidiary: localSubsidiary,
                currentUser: this.user.id,
            },
            () => {
                this.getData()
            }
        )

        this.getSubsidiaries()
        this.getUsers()
    }

    getCurrentWeek = () => {
        moment.updateLocale('es', {
            week: {
                dow: 5, // 0=domingo, 1=lunes, 2=martes, 3=miércoles, 4=jueves, 5=viernes, 6=sábado
            },
        })
        return moment().week()
    }

    onChangeWeek = async (value, option) => {
        this.setState(
            {
                currentWeek: value,
                dateRange: `${option.start},${option.end}`,
                loading: true,
            },
            () => {
                this.getData()
            }
        )
    }

    getUsers = async () => {
        this.setState({
            loading: true,
        })
        await API.get(`/api/users?pagination=false&filter[active]=1`)
            .then(response => {
                this.setState({
                    loading: false,
                    users: response.data,
                })
            })
            .catch(err => {
                console.error(err)
            })
    }

    getSubsidiaries = async () => {
        this.setState({
            loading: true,
        })

        await API.get('/api/subsidiaries?pagination=false&filter[active]=1')
            .then(response => {
                this.setState({
                    loading: false,
                    subsidiaries: response.data,
                })
            })
            .catch(err => {
                console.error(err)
            })
    }

    printAsPdfTicket = async record => {
        try {
            const ranges = getRangesWeeks(this.state.currentYear)
            const indexFind = ranges.findIndex(f => f.value === this.state.currentWeek)
            const option = ranges[indexFind];
            console.log('option', option);;
            const payload = {
                reportData: record,
                week: this.state.currentWeek,
                year: this.state.currentYear,
                subsidiary_id: this.state.currentSubsidiary,
                start_of_week: this.state.startOfWeek,
                end_of_week: this.state.endOfWeek,
                dateRange: option.start && option.end ? `${option.start},${option.end}` : this.state.dateRange,
            }
            const response = await API.post('/api/assistances/report/weekly', payload, { responseType: 'blob' })
            const { data } = response
            const url = window.URL.createObjectURL(data)
            const a = document.createElement('a')
            a.setAttribute('style', 'display: none;')
            a.setAttribute('href', url)
            a.setAttribute('target', '_blank')
            // a.setAttribute('download', `${fileName}.csv`);
            a.click()
            window.URL.revokeObjectURL(url)
        } catch (e) {
            console.log('ocurrió un error')
        } finally {
            console.log('finally')
        }
    }

    columns = [
        {
            title: 'Usuario ID',
            dataIndex: 'user_id',
            key: 'user_id',
        },
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Retardos',
            dataIndex: 'delay_hours',
            key: 'delay_hours',
        },
        {
            title: 'Faltas',
            dataIndex: 'daysAbsence',
            key: 'daysAbsence',
        },
        {
            title: 'Tiempo extra',
            dataIndex: 'extra_hours',
            key: 'extra_hours',
        },
        {
            title: 'Horas laboradas',
            dataIndex: 'hours',
            key: 'hours',
        },
        {
            title: 'Acciones',
            key: 'actions',
            render: (text, record) => {
                return (
                    <div>
                        <Button
                            type="primary"
                            shape="circle"
                            icon="download"
                            size="small"
                            style={{
                                margin: 5,
                            }}
                            onClick={() => this.printAsPdfTicket(record)}
                        />
                    </div>
                )
            },
        },
    ]

    getData = () => {
        const user_id = this.state.currentUser ? this.state.currentUser : this.state.user_id_exact;
        const newQuery = `&dateRange=${this.state.dateRange}&year=${this.state.currentYear}&user_id=${user_id}&subsidiary_id=${this.state.currentSubsidiary}&week=${this.state.currentWeek}`
        this.setState({
            loading: true,
            query: newQuery,
        })

        API.get(`/api/users/schedule/report?json=true${newQuery}`)
            .then(response => {
                this.setState({
                    loading: false,
                    data: response.data.data,
                    years: response.data.years,
                })
            })
            .catch(error => {
                console.error(error)
            })
    }

    render() {
        return (
            <>
                <div
                    style={{
                        backgroundColor: 'white',
                        borderRadius: 3,
                        padding: '8px 16px 16px',
                    }}
                >
                    <Spin spinning={this.state.loading} tip="Espere, por favor...">
                        <Divider>Reporte de asistencia semanal</Divider>

                        <Row gutter={24}>
                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Año">
                                    <Select
                                        style={{ width: '100%' }}
                                        value={this.state.currentYear}
                                        onChange={value => {
                                            this.setState(
                                                {
                                                    currentYear: value,
                                                },
                                                () => {
                                                    this.getData()
                                                }
                                            )
                                        }}
                                    >
                                        {this.state.years
                                            ? this.state.years.map((item, index) => (
                                                  <Option key={index} value={item}>
                                                      {item}
                                                  </Option>
                                              ))
                                            : null}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col lg={6} md={12} sm={24}>
                                <Form.Item label="Semana">
                                    <WeekPicker2
                                        value={this.state.currentWeek}
                                        year={this.state.currentYear}
                                        onChange={this.onChangeWeek}
                                    />
                                </Form.Item>
                            </Col>

                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Sucursal">
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Selecciona una sucursal"
                                        optionFilterProp="children"
                                        value={this.state.currentSubsidiary}
                                        onChange={value => {
                                            this.setState(
                                                {
                                                    currentSubsidiary: value,
                                                },
                                                () => this.getData()
                                            )
                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {this.state.subsidiaries.map(g => (
                                            <Option key={g.id} value={g.id}>
                                                {g.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Usuario">
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Selecciona un usuario"
                                        optionFilterProp="children"
                                        value={this.state.currentUser}
                                        onChange={value => {
                                            this.setState(
                                                {
                                                    currentUser: value,
                                                    user_id_exact: ''
                                                },
                                                () => this.getData()
                                            )
                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        <Option key="0" value="">
                                            Todas los usuarios
                                        </Option>
                                        {this.state.users.map(g => (
                                            <Option key={g.id} value={g.id}>{`${g.name} ${g.last_name}`}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col lg={2} md={12} sm ={24}>
                                <Form.Item label="Usuario ID">
                                    <Input
                                        type="text"
                                        value={this.state.user_id_exact}
                                        onChange={e => {
                                            if(+e.target.value){
                                                this.setState(
                                                    {
                                                        user_id_exact : e.target.value,
                                                        currentUser: ''
                                                    },
                                                    () => this.getData()
                                                )
                                            }
                                        }}
                                        />
                                </Form.Item>
                            </Col>
                        </Row>

                        <div className="ant-header-button">
                            <Tooltip title="Generar hoja de calculo" placement="left">
                                <Button
                                    style={{ marginRight: '10px' }}
                                    type="primary"
                                    shape="circle"
                                    icon="download"
                                    onClick={() =>
                                        (window.location.href =
                                            '/api/excel?table=assistancesWeek&pagination=false&json=false' +
                                            this.state.query)
                                    }
                                />
                            </Tooltip>
                        </div>

                        <Table dataSource={this.state.data} columns={this.columns} pagination={false} />
                    </Spin>
                </div>
            </>
        )
    }
}

export default ReportAssistancesWeeklyContainer
